"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneCbData = void 0;
var clone_deep_1 = __importDefault(require("clone-deep"));
var isFunction_1 = __importDefault(require("lodash/isFunction"));
var cloneCbData = function (data, references, structure) {
    var refs = references.reduce(function (acc, x) {
        if (structure[x]) {
            acc = acc.concat(structure[x].isDependedBy);
        }
        return acc;
    }, []);
    data = Object.keys(data).reduce(function (acc, x) {
        var value = data[x];
        if (refs.includes("internal." + x) || (0, isFunction_1.default)(data[x])) {
            acc[x] = value;
        }
        else {
            acc[x] = (0, clone_deep_1.default)(value);
        }
        return acc;
    }, {});
    return data;
};
exports.cloneCbData = cloneCbData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvbmVDYkRhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZ3JhcGgvY2xvbmVDYkRhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQ0EsMERBQW1DO0FBQ25DLGlFQUEyQztBQUVwQyxJQUFNLFdBQVcsR0FBRyxVQUN6QixJQUFlLEVBQ2YsVUFBb0IsRUFDcEIsU0FBeUI7SUFFekIsSUFBTSxJQUFJLEdBQUcsVUFBVSxDQUFDLE1BQU0sQ0FBQyxVQUFDLEdBQUcsRUFBRSxDQUFDO1FBQ3BDLElBQUksU0FBUyxDQUFDLENBQUMsQ0FBQyxFQUFFO1lBQ2hCLEdBQUcsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUFDLFNBQVMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxZQUFZLENBQUMsQ0FBQztTQUM3QztRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQWMsQ0FBQyxDQUFDO0lBRW5CLElBQUksR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFDLE1BQU0sQ0FBQyxVQUFDLEdBQVEsRUFBRSxDQUFDO1FBQzFDLElBQU0sS0FBSyxHQUFHLElBQUksQ0FBQyxDQUFDLENBQUMsQ0FBQztRQUN0QixJQUFJLElBQUksQ0FBQyxRQUFRLENBQUMsY0FBWSxDQUFHLENBQUMsSUFBSSxJQUFBLG9CQUFVLEVBQUMsSUFBSSxDQUFDLENBQUMsQ0FBQyxDQUFDLEVBQUU7WUFDekQsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLEtBQUssQ0FBQztTQUNoQjthQUFNO1lBQ0wsR0FBRyxDQUFDLENBQUMsQ0FBQyxHQUFHLElBQUEsb0JBQVMsRUFBQyxLQUFLLENBQUMsQ0FBQztTQUMzQjtRQUNELE9BQU8sR0FBRyxDQUFDO0lBQ2IsQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBRVAsT0FBTyxJQUFJLENBQUM7QUFDZCxDQUFDLENBQUM7QUF2QlcsUUFBQSxXQUFXLGVBdUJ0QiJ9